import { getAction, listAction } from "@/data/connection";
import { Image } from "@/components/blocks/image/image.class";


/**
 * Gets a center entry.
 */
export const getPageEntry = function (value) {
	return getAction('pages', value, 'slug').then(data => {
		if (data.data[0])
			return processEntry(data.data[0]);
		if (data.data)
			return processEntry(data.data);
	});
}

/**
 * Gets a list of centers.
 */
export const getPagesList = function () {
	return listAction('pages').then(data => {
		return processList(data.data);
	});
}

/**
 * Gets a Template Page entry.
 */
export const getTemplatePage = function (value) {
	return getAction('templates', value, 'slug').then(data => {
		// console.log("Data", data)
		
		if (data.data){
			if (data.data[0])
				return processEntry(data.data[0]);
			else
				return processEntry(data.data);
		}
	});
}

/**
 * Gets a list of Template Pages.
 */
export const getTemplateList = function (value) {
	return listAction('templates', value).then(data => {
		return processList(data.data);
	});
}

/**
 * Process Entry.
 */
const processEntry = function (data) {
	let content = data;
	if (content.better_featured_image)
		content.better_featured_image = new Image(content.better_featured_image);

	if (content.meta_box.gallery) {
		content.meta_box.gallery = content.meta_box.gallery.map(image => {
			return new Image(image);
		});
	}
	return content;
}

/**
 * Process List.
 */
const processList = function (data) {
	let content = data;

	content.map(edition => {
		processEntry(edition)
	})

	return content;
}


// WEBPACK FOOTER //
// ./src/data/models/page.model.js